<div class="case-detail-layout">
  <section class="case-detail-layout__main" aria-label="Case details">
    <ng-content select="[main-content]" />
  </section>
  <aside class="case-detail-layout__sidebar" aria-label="Quick actions and templates">
    <ng-content select="[sidebar-content]" />
  </aside>
</div>
